import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetModelsResponse,
  GetModelRequestParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onError?: (error: Error) => void
  onSuccess?: (response: GetModelsResponse) => void
  children?: (response: GetModelsResponse) => ReactElement
  shortErrorMessage?: string
  params?: GetModelRequestParams
}

const GetAiModelsRequest = ({
  onError,
  onSuccess,
  children,
  shortErrorMessage,
  params
}: Props) => {
  const url = `${AI_API_SERVICE}/models`

  const { requestParams } = useGetParamsWithSpaceId({})

  const updatedParams = params
    ? {
      ...requestParams,
      ...params
    }
    : requestParams

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={updatedParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetAiModelsRequest
